var res = [{"key":"10/11","value":"42.4"},{"key":"11/12","value":"31.2"},{"key":"12/13","value":"33.8"},{"key":"13/14","value":"29.8"},{"key":"14/15","value":"24.0"},{"key":"15/16","value":"19.3"},{"key":"16/17","value":"19.8"}];res.columns = ["key","value"];module.exports = res;


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/minutes-london.csv
// module id = 623
// module chunks = 0